import React from 'react';
import PropTypes from 'prop-types';

import QuokkaTemplateDefaultsModal from '../modals/quokka_template_defaults_modal';
import useEditorModal from '../../hooks/quokka_template_defaults_editor/use_editor_modal';
import { ApplyTemplateDefaultsToAllSitesButton } from './apply_template_defaults_to_all_sites_button';

const QuokkaTemplatesInUseSection = ({ templatesData, enableApplyDefaultsToAllSites }) => {

  const {
    open,
    onClose,
    refreshQuokkaData,
    setTemplateToEditId,
    quokkaIframeData
  } = useEditorModal(templatesData);

  return (<React.Fragment>
    {templatesData.map(templateData => (
      <div className="border d-flex p-4 align-items-center mb-4" key={templateData.template.id}>
        <div className="flex-grow larger-text">
          <b>{templateData.template.name}</b>
          <p className="m-0"></p>
          Used by
          <b className="ms-1">{templateData.associatesUsingTemplate}</b>
        </div>

        <div className="d-flex ms-auto">
          {enableApplyDefaultsToAllSites &&
            <ApplyTemplateDefaultsToAllSitesButton
              applyDefaultsToAllSitesPath={templateData.applyDefaultsToAllSitesPath}
              applying={templateData.applyingDefaultsToAllSites}
              monitorPath={templateData.applyDefaultsStatusPath}
            />}
          <button
            className="m-1 btn btn-secondary"
            onClick={() => setTemplateToEditId(templateData.template.id)}
          >
            Edit Default Options
          </button>
        </div>
      </div>
    ))}

    <QuokkaTemplateDefaultsModal
      iframeData={quokkaIframeData}
      open={open}
      refreshQuokkaData={refreshQuokkaData}
      onClose={onClose}
    />
  </React.Fragment>
  );
};

QuokkaTemplatesInUseSection.propTypes = {
  enableApplyDefaultsToAllSites: PropTypes.bool,
  templatesData: PropTypes.arrayOf(PropTypes.shape({
    template: PropTypes.object.isRequired,
    associatesUsingTemplate: PropTypes.string
  })).isRequired,
};

export default QuokkaTemplatesInUseSection;
